import {useTranslation} from "react-i18next";
import {useState} from "react";
import ReactModal from 'react-modal';
import PromoCode from "../../../Payment/PromoCode";
import { v4 as uuidv4 } from 'uuid';

export default function BuyTicketButton({id, tickets}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <button onClick={() => setShowModal(true)} type="button"
                    className="btn-conference-page wide btn-primary"
            >
                { t('conferences.buyTicket') }
            </button>
            <ReactModal
                isOpen={showModal}
                overlayClassName={'overlay is-visible'}
                onRequestClose={() => setShowModal(false)}
                className={'popup'}
                shouldCloseOnOverlayClick={true}
            >
                <div key={uuidv4()} className="popup-buy-tickets">
                    { tickets.map((ticket) => {
                        return (
                            <div className="ticket-block">
                                <div className="ticket-description-container">
                                    <div className="ticket-name">
                                        {ticket.name}
                                    </div>
                                    <div className="ticket-description">
                                        {ticket.description}
                                    </div>
                                </div>
                                <div className="ticket-select-block">
                                    <button
                                        onClick={() => window.location.href = '/payment/conferences/' + ticket.id}
                                        className="btn-conference-page btn-primary" type="button">
                                        {ticket.price}
                                        { t('app.currencies.uah') }.
                                    </button>
                                </div>
                            </div>
                        )
                    }) }
                    <h3>{ t('conferences.or') }</h3>
                    <PromoCode />
                </div>
            </ReactModal>
        </div>
    )
}
